export const COMMENT_SOURCE_TYPE_SELF = 'self';

// マスタの comment_features_by_source_type で使われる項目
export const COMMENT_FEATURES = {
  DAMAGE_RANK: 'damage_rank',
} as const;
export type CommentFeature = typeof COMMENT_FEATURES[keyof typeof COMMENT_FEATURES];
